/* tslint:disable */
/* eslint-disable */

import { ReaderInlineDataFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type sharedMessageHelpers_messages = {
    readonly items: ReadonlyArray<{
        readonly note: {
            readonly serviceId: string | null;
            readonly content: {
                readonly message: string | null;
            } | null;
            readonly anchors: ReadonlyArray<{
                readonly content: {
                    readonly message: string | null;
                } | null;
            } | null> | null;
        } | null;
    } | null> | null;
    readonly " $refType": "sharedMessageHelpers_messages";
};
export type sharedMessageHelpers_messages$data = sharedMessageHelpers_messages;
export type sharedMessageHelpers_messages$key = {
    readonly " $data"?: sharedMessageHelpers_messages$data;
    readonly " $fragmentRefs": FragmentRefs<"sharedMessageHelpers_messages">;
};



const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "sharedMessageHelpers_messages"
};
(node as any).hash = '8592a0b862059b15272e45a693706824';
export default node;
